import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  email: "",
  code: "",
  password: "",
  mobile: "",
  firstName: "",
  lastName: "",
  agreedToTerms: false,
  isAuthenticated: false,
  buyer: null,
  isLoading: true, // initially loading
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setEmail: (state, action) => {
      state.email = action.payload;
    },
    setCode: (state, action) => {
      state.code = action.payload;
    },
    setPassword: (state, action) => {
      state.password = action.payload;
    },
    setMobile: (state, action) => {
      state.mobile = action.payload;
    },
    setFirstName: (state, action) => {
      state.firstName = action.payload;
    },
    setLastName: (state, action) => {
      state.lastName = action.payload;
    },
    setAgreedToTerms: (state, action) => {
      state.agreedToTerms = action.payload;
    },
    setAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload;
    },
    setBuyer: (state, action) => {
      state.buyer = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },

    resetAuthState: () => initialState,
  },
});

export const {
  setEmail,
  setCode,
  setPassword,
  setMobile,
  setFirstName,
  setLastName,
  setAgreedToTerms,
  setAuthenticated,
  resetAuthState,
  setLoading,
  setBuyer,
} = authSlice.actions;

export default authSlice.reducer;
